import React, { useState } from 'react';
import Modal from '../../components/common/Modal';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { useApi } from '../../hooks/useApi';
import { addLedgerEntry } from '../../lib/api/ledger';
import { useAuth } from '../../contexts/AuthContext';
import { useError } from '../../contexts/ErrorContext';
import SafeIcon from '../../common/SafeIcon';

export default function AddEntryModal({ kidId, initialType = 'add', onClose, onSuccess }) {
  const { user } = useAuth();
  const { showError } = useError();
  const { execute, loading } = useApi(addLedgerEntry);
  
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [type, setType] = useState(initialType);

  const handleCurrencyChange = (value) => {
    const regex = /^\d*\.?\d{0,2}$/;
    if (value === '' || regex.test(value)) {
      setAmount(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const numAmount = parseFloat(amount);
    if (isNaN(numAmount) || numAmount <= 0) return showError("Please enter a valid amount greater than 0");
    
    const finalAmount = type === 'subtract' ? -Math.abs(numAmount) : Math.abs(numAmount);
    
    await execute(kidId, user.id, finalAmount, note.trim());
    onSuccess();
    onClose();
  };

  return (
    <Modal title={type === 'add' ? 'Add Funds' : 'Spend/Deduct'} onClose={onClose}>
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="grid grid-cols-2 gap-3">
          <button 
            type="button"
            onClick={() => setType('add')}
            className={`p-3 rounded-xl border-2 flex items-center justify-center font-bold transition-all ${type === 'add' ? 'border-green-500 bg-green-50 text-green-700' : 'border-gray-100 text-gray-400 hover:bg-gray-50'}`}
          >
            <SafeIcon icon="Plus" className="mr-2 w-5 h-5" />
            Funds
          </button>
          <button 
            type="button"
            onClick={() => setType('subtract')}
            className={`p-3 rounded-xl border-2 flex items-center justify-center font-bold transition-all ${type === 'subtract' ? 'border-red-500 bg-red-50 text-red-700' : 'border-gray-100 text-gray-400 hover:bg-gray-50'}`}
          >
            <SafeIcon icon="Minus" className="mr-2 w-5 h-5" />
            Spend
          </button>
        </div>

        <Input 
          label="Amount ($) *" 
          type="text"
          inputMode="decimal"
          placeholder="0.00" 
          value={amount} 
          onChange={e => handleCurrencyChange(e.target.value)}
          autoFocus
          required
        />
        
        <Input 
          label="Note (Optional)" 
          placeholder={type === 'add' ? 'e.g. Chores' : 'e.g. Toy'} 
          value={note} 
          onChange={e => setNote(e.target.value)} 
        />

        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-100">
          <Button variant="ghost" type="button" onClick={onClose}>Cancel</Button>
          <Button type="submit" loading={loading} icon="Save">Save</Button>
        </div>
      </form>
    </Modal>
  );
}